import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Health() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [healthData, setHealthData] = useState([]);
  const [error, setError] = useState(null);

  // Topic IDs for US Health API
  const topicIds = [530, 531, 532, 533, 534, 536, 537, 538, 539, 540, 541, 544];

  useEffect(() => {
    async function loadNews() {
      try {
        const data = await fetchNewsByCategory("health");
        setNews(data);
      } catch (err) {
        console.error("Error fetching health news:", err);
      } finally {
        setLoading(false);
      }
    }
    loadNews();
  }, []);

  useEffect(() => {
    const fetchHealthTopics = async () => {
      const topicsData = [];
      for (const topicId of topicIds) {
        try {
          const response = await axios.get(
            `https://health.gov/myhealthfinder/api/v3/topicsearch.json`,
            { params: { lang: "en", topicId, Type: "topic" } }
          );
          const topic = response.data.Result.Resources.Resource[0];
          if (topic) topicsData.push(topic);
        } catch (err) {
          console.error(`Error fetching topic ${topicId}:`, err);
        }
      }
      setHealthData(topicsData);
    };
    fetchHealthTopics();
  }, []);

  if (loading)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    );

  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <Helmet>
        <title>
          Latest Health Updates | Diet, Fitness & Medical News – BharatAbroad
        </title>
        <meta
          name="title"
          content="Latest Health Updates | Diet, Fitness & Medical News India – BharatAbroad"
        />
        <meta
          name="description"
          content="Get the latest health news, fitness tips, diet updates, medical breakthroughs, wellness trends, and healthcare updates from India and around the world on BharatAbroad."
        />
        <meta
          name="keywords"
          content="health news India, fitness tips India, diet updates India, medical breakthroughs India, wellness trends India, healthcare updates India, latest health news today, health alert India, vaccine update India, hospital medical update India, big health update India, health news worldwide, fitness trends 2026, diet tips India, mental health India news, yoga wellness India, Ayurveda health news, nutrition updates India, health insurance India news, medical research India, pharmacy news India, disease outbreak India news, cancer treatment India updates, diabetes news India, heart health India, weight loss tips India, healthy lifestyle India, medicine updates India, doctor advice India, health ministry India news, ICMR updates India, WHO India health news, BharatAbroad health, BharatAbroad wellness, BharatAbroad fitness news"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Latest Health News & Wellness Updates – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Get the latest health news, fitness tips, diet updates, medical breakthroughs, wellness trends, and healthcare updates from India and around the world on BharatAbroad."
        />
        <meta property="og:site_name" content="BharatAbroad" />
        <meta property="og:url" content="https://www.bharatabroad.com/health" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-health.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Latest Health News & Wellness Updates – BharatAbroad"
        />
        <meta
          name="twitter:description"
          content="Stay updated with the latest health news, fitness trends, diet tips, medical updates, wellness advice, and healthcare developments from India and worldwide on BharatAbroad."
        />
        <meta
          name="twitter:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-health.png"
        />
        <meta name="twitter:site" content="@BharatAbroad" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/health" />
      </Helmet>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <NewsSection title="Health News" articles={news} category="health" />
        </div>
      </div>

      {/* <div style={{ backgroundColor: "#eeeeee", padding: "20px 0" }}>
        <Container className="col-lg-11">
          <h4 className="pt-3 ms-2 fw-bolder">US Health Topics</h4>
          {healthData.length > 0 ? (
            <Row className="g-3">
              {healthData.map((topic, index) => (
                <Col md={6} lg={3} key={index}>
                  <Card className="border-0 shadow">
                    <Card.Img variant="top" src={topic.ImageUrl} />
                    <Card.Body className="p-2" style={{ minHeight: "100px" }}>
                      <Card.Text>
                        <h6 className="fw-bold">{topic.Title}</h6>
                        <small>{topic.Categories}</small>
                      </Card.Text>
                      <div className="text-end">
                        <Link
                          to={`/health/${topic.Id}`}
                          className="btn btn-dark btn-sm"
                        >
                          Read More
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <p>Loading US health topics...</p>
          )}
        </Container>
      </div> */}
    </>
  );
}

export default Health;
